import React, { Component } from 'react'
import { Grid, Button, Icon, Loader, Image, Dropdown} from 'semantic-ui-react'
import InputField from '../../formComponents/inputField'
import { createMerchandiseLineItem } from '../../api/createItem'
import MerchandiseLineItems from './MerchandiseLineItems'
import * as actionCreators from '../../actions'
import { connect } from 'react-redux'
import { get } from 'lodash'
import Images from '../../config/images'
import CreateArticleSet  from './createArticleSet';
import PopUpIcon from '../../formComponents/PopUpIcon';
import _ from "lodash";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import {loadCurrenciesConversionRates, saveInvoiceLineItemFeildBetterObject} from '../../api/setFormData'
import { changeEnteredValueDutyLevel, saveWholeInvoiceEnteredValue } from './DutyItem'
import SelecTextField from '../../formComponents/selectTextField'
import { checkFrieghtShouldBeDispalyed } from '../util/initialValues'
import { merchandiseListToTotalAmount } from '../util/index'
import {propsAreEqual_NoRerenderNeeded} from '../../reducer/util'

setTimeout(() => {
  if (document.getElementById("kn-hamberger") && localStorage.getItem("showedAlertForSVB") != 'true' && Date.now() < 1680227534709) {
    confirmAlert({
      closeOnClickOutside: true,
      title: `Updated banking information effective immediately`,
      message: <>
        <p>
          For our US customers we would like to address recent breaking news regarding Silicon Valley Bank and want to assure you that KlearNow operations remain unaffected by this situation. All future banking transactions have been moved to one of our other banking partners, Merrill Lynch. This change is effective immediately, and we apologize for any inconvenience this may cause.
        </p>
        <p>
          Please call your current KlearNow contact for updated account information.
        </p>
        <p><span style={{ fontStyle: 'italic' }}>
          Sincerely,<br />
          KlearNow
        </span>
        </p>
      </>,
      buttons: [
        { label: `Ok`, onClick: () => { } }
      ]
    })
    localStorage.setItem("showedAlertForSVB", 'true');
  }
}, 3500)
class InvoiceLineItem extends Component {
    constructor(props) {
        super(props)
       this.state = {
         isDeleting: false,
         isAdding: false,
         expandAllLines: false,
         articleSetModal: false,
         error:{},
         getCurrencyConversionRate:{},
         getLoadedCurrencies: {},
       };
       this.validateInvoiceAmount = this.validateInvoiceAmount.bind(this)
       this.getFreightDataValidationError = this.getFreightDataValidationError.bind(this)
    }

    handleModalOpen = (modal) => {
      this.setState({ [modal]: true })
    }
  
    handleModalClose = (modal) => {
      this.setState({ [modal]: false })
    }

    open = () => this.setState({ open: true })
    close = () => this.setState({ open: false })

    showHideLineItem = (invoiceItemIndex) => {
      this.props.hideUnhideInvoiceItem(invoiceItemIndex)
      } 
    
      showInvoiceItem = (invoiceItemIndex) => {
        this.props.closeInvoiceItem(invoiceItemIndex)
        } 
      updateAddStatus = () => {
        setTimeout(() => {
        this.setState({
          isAdding: false
        }) } ,350)
      }
    
      updateDeleteStatus = () => {
        this.setState({
          isDeleting: false
        })
      }

     validateInvoiceAmount =(lineItems)=>{
       let booleanArray = []
       let errorMesg=[]
        lineItems.forEach(element => {
          for(let i = 0 ; i < element.merchandiseDuties.length ; i++){
              let hts = element.merchandiseDuties[i].htsus;
              let is98_99_chp = ["98", "99"].includes(hts.substring(0,2));  
               if(element.merchandiseDuties[i].isCommodityDuty === 2 && is98_99_chp){
                  continue;
               }
               booleanArray.push(element.merchandiseDuties[i].enteredValue) 
          }
        })
        console.log(booleanArray,"booleanArray")
        if(booleanArray.includes("0.00")){
          let  obj ={ title : `Some of the line items have 0 entered value. ` , message :`Please enter the entered value before freight charges can be added to this invoice.`}
        errorMesg.push(obj)
          return errorMesg
        }
        else  if(booleanArray.length === 0){
          let  ob ={ title : `No line Items Present . ` , message :`Please add line items and enter the entered value before freight charges can be added to this invoice.`}
          errorMesg.push(ob)
          return errorMesg
        }else{
        
          return errorMesg
        }
      }


     getFreightDataValidationError = (field, frieghtCharges, frieghtInsurance, otherDeductions, invoiceAmount, otherAdditions="") => {

       let errors = [];
       let isblank = (str)=>{
         if(typeof str !== "string")return false;
         return !str || str.trim() === ""
       }
       if (isblank(frieghtCharges)) {
         frieghtCharges = 0.00
       }
       if (isblank(frieghtInsurance)) {
         frieghtInsurance = 0.00
       }
       if (isblank(otherDeductions)) {
         otherDeductions = 0.00
       }
       if (isblank(otherAdditions)) {
        otherAdditions = 0.00
      }
       if (isblank(invoiceAmount)) {
         invoiceAmount = 0.00
       }


       if (parseFloat(frieghtCharges) + parseFloat(frieghtInsurance) + parseFloat(otherDeductions) > parseFloat(invoiceAmount)) {

         errors.push("Sum of freight charges, freight insurance and other deductions cannot be greater than invoice amount.");


       }

       return errors;
     };

      shouldComponentUpdate(nextProps, nextState){
        return ((this.state.currentValueRerenderer || 0)+15000)>Date.now() || !propsAreEqual_NoRerenderNeeded(this.state,nextState) || !propsAreEqual_NoRerenderNeeded(this.props,nextProps);
      }
      render() {
        console.log(this.props,'this.propsthis.propsthis.props(((((((((((((((((')
        let {
          invoice,
          invoiceItemIndex,
          invoiceId,
          invoiceNumber,
          invoiceDate,
          totalEnteredValue,
          frieghtCharges,
          currencyExchangeInfo,
          otherDeductions,
          otherAdditions,
          frieghtInsurance,
          poNumber,
          invoiceAmount,
          merchandiseLineItems,
          totalInvoiceItems,
          newValue,
          incoterm1,
          updateInvoiceLineItemFeild,
          saveInvoiceLineItemFeild,
          removeInvoiceLineItem,
          removeFrieghtLevelDetails,
          dispalyLoader,
          showLoader,
          fieldName,
          refreshESFrom,
          setINPUTID,
          penClicked,
          shipmentId,
          isDisabled,
          rbCounterID,
          pscData,
          shipmentETA,
          fieldValidation,
          currentJobData,
          exportDateq,
          foreignCurrencyToUsdExchangeRate,
          currencyAssists,
          countryOfExport,
          allCurrencyCodes,
          isBrokerKnAdmin,
          countriesToCurrenciesConv,
          updateMerchDutyItemFeild,
          saveMerchDutyItem,
          totalCharges,
          totalAdditions,
          totalDeletions
        } = this.props;
       
        
        fieldValidation = fieldValidation||{};
        fieldValidation.validObjects_bl = fieldValidation.validObjects_bl ||{};


        let epochToMMDDYY = (epochx) => {return (new Date(epochx).getUTCMonth() + 1).toString().padStart(2, "0")
        + new Date(epochx).getUTCDate().toString().padStart(2, "0")
        + (new Date(epochx).getUTCFullYear() % 100).toString().padStart(2, "0")}
        
        let hasAnyFreight = (parseFloat(otherDeductions||0.00) ||parseFloat(otherAdditions||0.00) ||parseFloat(frieghtInsurance||0.00) || parseFloat(frieghtCharges||0.00) );
        
        let updateExchangeRateForForeignCurrency = (newExchangeRate,hasAnyFreight,forceChange, overridingExchangeRate)=>{
          let hasAnyFreightString = hasAnyFreight?"YYYY":"NNNN"
          if(this.state.lastConversion == newExchangeRate && this.state.lastHasAnyFreight == hasAnyFreightString && !forceChange)return; 
          this.setState({lastConversion: newExchangeRate});
          this.setState({lastHasAnyFreight: hasAnyFreightString});
          
          let newExchangeInfo = {
            ...currencyExchangeInfo,
            exchangeDate: epochToMMDDYY(exportDateq.epochs),
            exchangeRate:newExchangeRate,
          };
          if(overridingExchangeRate != "noChange"){
            newExchangeInfo.enteredManuallyByBroker = overridingExchangeRate?"true":"false";
          }
          updateInvoiceLineItemFeild(
            invoiceItemIndex,
            "currencyExchangeInfo",
            newExchangeInfo
          );

          saveInvoiceLineItemFeildBetterObject(invoiceId, {
            currencyExchangeInfo:newExchangeInfo
          });
          for (let onemerch of merchandiseLineItems) {
            let merchLineItemIndex = merchandiseLineItems.indexOf(onemerch);
            for (let oneDuty of (onemerch.merchandiseDuties || [])) {
              let newEnteredValue = oneDuty.invoiceCurrencyValue * newExchangeRate;
              let oneDutyIndex = onemerch.merchandiseDuties.indexOf(oneDuty);
              if (!hasAnyFreight) {
                newEnteredValue = Math.round(newEnteredValue)
              }
              if (oneDuty.isCommodityDuty == "1") {
                changeEnteredValueDutyLevel(newEnteredValue,
                  merchLineItemIndex,
                  invoiceItemIndex,
                  oneDutyIndex, this.props, onemerch.merchandiseDuties, false);

              } else {
                
                updateMerchDutyItemFeild(
                  invoiceItemIndex,
                  merchLineItemIndex,
                  oneDutyIndex,
                  "invoiceCurrencyValue",
                  (parseFloat(oneDuty.enteredValue || 0) / (newExchangeRate||1)).toFixed(2)
                );
                saveMerchDutyItem(
                  merchLineItemIndex,
                  invoiceItemIndex,
                  oneDutyIndex,
                  "invoiceCurrencyValue"
                );
              }
            }
          }
          saveWholeInvoiceEnteredValue(this.props,invoiceItemIndex,shipmentId)
        }

        let totalForeignValue = merchandiseListToTotalAmount(merchandiseLineItems).toFixed(2);
     
        let { getCurrencyConversionRate, getLoadedCurrencies } = this.state;

        let uniqueCurrencyId = `${exportDateq?.epochs} + ${countryOfExport} + ${currencyExchangeInfo.fromIsoCurrencyCode}`;
        let currentExchangeRate = currencyExchangeInfo.exchangeRate || getCurrencyConversionRate[uniqueCurrencyId];
        

        const isTheOwningBroker = !this.props?.kxUserBasicInfo?.userGuid ||  !this.props?.currentJobData?.brokerGuid || this.props?.kxUserBasicInfo?.userGuid  == this.props?.currentJobData?.brokerGuid;
        let isPscMode = isTheOwningBroker && get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY';
        const exchangeRateIsDisabled = (isPscMode ? false: isDisabled('invoiceItem')) || !currencyExchangeInfo?.fromIsoCurrencyCode;
        if(!isBrokerKnAdmin && !this.state.exchangeRateFocusedYes && !exchangeRateIsDisabled){
          if(currencyExchangeInfo.fromIsoCurrencyCode == "USD"){
            let currentObject = getCurrencyConversionRate;
            currentObject[uniqueCurrencyId] =  1;
            if(currentExchangeRate != 1 && !isBrokerKnAdmin || this.state.currencyJustChanged){
              updateExchangeRateForForeignCurrency(1,hasAnyFreight,false, false);
            }
            if(!_.isEqual(this.state.getCurrencyConversionRate,currentObject) ||  this.state.currencyJustChanged){
              this.setState({getCurrencyConversionRate:currentObject, currencyJustChanged: false});
            }
          } else {
            let currentObject = getCurrencyConversionRate;
            let MAX_CURRENCY_CALCULATIONERROR_DOLLARS = Math.max(
              (parseInt(invoiceAmount||"0")*0.00002) || 2,//a small percent of the total invoice
                (merchandiseLineItems||[]).reduce((accumulator, currencyObject)=>{//the total number of duties
                  return (currencyObject?.merchandiseDuties?.length||1)+accumulator
                },0),
                2//2 dollars
            );//whichever is largest!
            let getCalculationError = ()=>{
              return Math.abs(parseFloat(totalForeignValue) * parseFloat(currentExchangeRate) - parseFloat(invoiceAmount));
            }
            let hasCalculationError = totalForeignValue && currentExchangeRate && invoiceAmount && getCalculationError() > MAX_CURRENCY_CALCULATIONERROR_DOLLARS;
            if (!getCurrencyConversionRate[uniqueCurrencyId] && !getLoadedCurrencies[uniqueCurrencyId] && exportDateq?.epochs && countryOfExport && currencyExchangeInfo.fromIsoCurrencyCode) {
              this.setState({getLoadedCurrencies: {...getLoadedCurrencies,[uniqueCurrencyId]:true}});
              loadCurrenciesConversionRates(countryOfExport, currencyExchangeInfo.fromIsoCurrencyCode, epochToMMDDYY(exportDateq.epochs)).then(response => {
                let rateee = _.get(response, "data.eventMessage.exchangeRate", 0);
                if (rateee) {
                  if ((parseFloat(rateee) != parseFloat(currentExchangeRate)) && !isBrokerKnAdmin && currencyExchangeInfo.enteredManuallyByBroker!="true") {
                    updateExchangeRateForForeignCurrency(rateee, hasAnyFreight, false, false);
                  }
                  currentObject[uniqueCurrencyId] = parseFloat(rateee)
                  this.setState({ getCurrencyConversionRate: currentObject, currentValueRerenderer:Date.now() });

                }

              });
            } 
            // else if(hasCalculationError){
            //   if(!isBrokerKnAdmin){
            //     if(getCalculationError() != this.state.lastCalculationError){
            //       this.setState({lastCalculationError: getCalculationError()});
            //       updateExchangeRateForForeignCurrency(currentExchangeRate, hasAnyFreight, false);
            //     }
            //   }
            // }
          }
        }

       let trueExchangeRate = getCurrencyConversionRate[uniqueCurrencyId]
        
        let formDisabled = this.props.formDisabled;
        if(this.state.enableLineItem === true){
          formDisabled = false;
        }
        let warningsforInvoice = fieldValidation.warnings
          .filter(a=>a.invoice && a.invoice.includes(invoiceId))
          .filter(a=>a.warntype !== 'warning') || [];
        const invoiceIndex = (invoiceItemIndex + 1).toString().length === 1 ? `00${invoiceItemIndex + 1}` : (invoiceItemIndex + 1).toString().length === 2 ? `0${invoiceItemIndex + 1}` : invoiceItemIndex + 1
        let allcurrenciesForUI = (countriesToCurrenciesConv[countryOfExport]||[]).map(a=>{
           return ({
            id:a.IsoCurrencyCode,
            description:a.IsoCurrencyDescription,
          })
        }).concat({
          id:'USD',
          description: 'United States Dollar',
        }).concat({
          id:'-',
          description: '-',
        }).concat(allCurrencyCodes
          .filter(a=>a)
          .map(a=>{
          return ({
            id:a.IsoCurrencyCode,
            description:a.IsoCurrencyDescription,
          })
        }));
        let seencurrencies = []
        allcurrenciesForUI=allcurrenciesForUI.filter(a=>{
            if(!seencurrencies.includes(a?.id)){
                seencurrencies.push(a?.id);
                return true;
            }
            return false;
        });
        let hasMerchAndOrIsntBolUpdate = merchandiseLineItems?.length > 0 || "cargoReleaseUpdate"!=this.props.updateType;
        
        let isPSCEditable = isTheOwningBroker &&(get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY');
      
        return (
          <div className="merchandise-line-item" key={invoiceId}>
           <a href="#" onFocus={()=>{
             if(!this.props.expandInvoiceItem){
                this.showHideLineItem(this.props.invoiceItemIndex)
                setTimeout(()=>{
                  document.getElementById(`${invoiceItemIndex}invoiceNumber${shipmentId}`) && document.getElementById(`${invoiceItemIndex}invoiceNumber${shipmentId}`).focus()
                },20)
              }
           }} name={"asdfg" + invoiceId}></a>
           {this.props.expandInvoiceItem &&    <a
                      color="blue"
                      className="btn-add-item"
                      style={{"float":"right"}}
                      onClick={() => {
                        if(merchandiseLineItems.length >  0 ){
                          dispalyLoader(invoiceItemIndex);
                        setTimeout(() => {
                          this.setState({
                            expandAllLines: !this.state.expandAllLines,
                          });
                        }, 0);
                        }
                      
                      }}
                      // disabled={this.state.isAdding}
                    >
                      {this.props.showLoader === false ? (
                        <span
                          className={"expandAllSection"}
                          style={{ cursor: "pointer" }}
                        >
                         {this.state.expandAllLines
                            ? "Collapse All Lines"
                            : "Expand All Lines"}
                        </span>
                      ) : (
                        <span>
                          <Loader
                            active
                            inline
                            size="mini"
                            style={{ marginRight: "10px" }}
                          />
                          Loading...
                        </span>
                      )}
                    </a>}
            <table style={{ marginTop: "10px" }}>
              <tbody>
                <tr>
                  <td>
                    <div
                      className="stepNumber"
                      onClick={() => {
                        this.props.expandInvoiceItem === false ?   this.showHideLineItem(this.props.invoiceItemIndex)  : this.showInvoiceItem(this.props.invoiceItemIndex)
                      }}
                    >
                      <Icon
                        id={this.props.expandInvoiceItem ? `minus-invoice-${invoiceId}`: `plus-invoice-${invoiceId}`}
                        name={
                          this.props.expandInvoiceItem
                            ? `minus circle`
                            : `plus circle`
                        }
                      />
                      {"Invoice: "+invoiceIndex}

                      {warningsforInvoice.length ?<span style={{color:'red'}}>&nbsp;Errors: {warningsforInvoice.length}</span>:""}
                    </div>
                   
                  </td>
                  <td style={{"paddingLeft":"10px", marginRight:"10px"}}>
                    { totalInvoiceItems > 1 && (
                      <>
                        <Grid.Column className="delete-line-item">
                          <Button
                            className={"del-line-item-btn"}
                            basic
                            color="blue"
                            compact
                            circular
                            onClick={() => {
                              if (
                                !window.confirm(
                                  (hasMerchAndOrIsntBolUpdate?"Are you sure? Remove Invoice Line Item ":"Deletion of empty invoice ") +
                                    invoiceIndex
                                )
                              )
                                return;
                              this.setState({
                                isDeleting: true,
                              });
                              removeInvoiceLineItem(
                                invoiceId,
                                this.updateDeleteStatus
                              );
                            }}
                           disabled={isPscMode ? false: isDisabled('invoiceItem')?
                           hasMerchAndOrIsntBolUpdate
                           :false}//
                          >
                            {!this.state.isDeleting ? (
                              <span>
                                <Icon name="trash alternate outline" />
                                {/* <!-- text goes here-- */}
                              </span>
                            ) : (
                              <span>
                                <Loader
                                  active
                                  inline
                                  size="mini"
                                  style={{ marginRight: "10px" }}
                                />
                                Deleting Invoice Line Item
                              </span>
                            )}
                          </Button>
                        </Grid.Column>
                      </>
                    )}
                  </td>
                  {invoice?.mbol ? <div
                   onClick={() => {
                    this.props.expandInvoiceItem === false ?   this.showHideLineItem(this.props.invoiceItemIndex)  : this.showInvoiceItem(this.props.invoiceItemIndex)
                  }}
                  className="billOfLading"> <b>MBL:</b> {invoice?.mbol}</div>: null}
                  {invoice?.hbol ? <div
                   onClick={() => {
                    this.props.expandInvoiceItem === false ?   this.showHideLineItem(this.props.invoiceItemIndex)  : this.showInvoiceItem(this.props.invoiceItemIndex)
                  }}
                  className="billOfLading"> <b>HBL:</b> {invoice?.hbol}</div>: null}
                  {invoice?.hasTimeOfEntry === "Y" && (
                      <span title="Time of Entry">
                        &nbsp;
                        <b style={{ color: "#008080", fontSize: "1.25rem" }}>𝘛𝘖𝘌</b>
                      </span>
                    )}
                </tr>
              </tbody>
            </table>
            {this.props.expandInvoiceItem && (
              <Grid padded className="nopadcol blk2 extra-fees">
                <Grid.Row className="merged hts-row">
                  <Grid.Column className="no-field-margin" width="5">
                    <InputField
                      id={`${invoiceItemIndex}invoiceNumber`}
                      errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'invoiceNumber'+invoiceId}`]}
                      disabled={isPscMode ? false: isDisabled('invoiceItem')}
                      type={"text"}
                      className={"field-bg"}
                      label={"invoice number"}
                      value={invoiceNumber  ==="-999" ?  "" :  invoiceNumber||''}
                  //    isInteger={true}
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(value) => {
                        updateInvoiceLineItemFeild(
                          invoiceItemIndex,
                          "invoiceNumber",
                          value
                        );
                      }}
                      onBlur={(value) => {
                        saveInvoiceLineItemFeild(
                          invoiceItemIndex,
                          "invoiceNumber"
                        );
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column className="no-field-margin" width="4">
                    <InputField
                      id={`${invoiceItemIndex}invoiceDate`}
                      icon={<Image src={Images.calender_icon} />}
                      errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'invoiceDate'+invoiceId}`]}
                      disabled={isPscMode ? false: isDisabled('invoiceItem')}
                      type={"date"}
                      className={"field-bg"}
                      label="invoice date"
                      value={
                        (invoiceDate && invoiceDate > 10000) 
                          ? new Date(
                              new Date(parseInt(invoiceDate)).getUTCMonth() +
                                1 +
                                "/" +
                                new Date(parseInt(invoiceDate)).getUTCDate() +
                                "/" +
                                new Date(parseInt(invoiceDate)).getUTCFullYear()
                            ).getTime()
                          : -999
                      }
                      //  isInteger={true}
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(value) => {
                        if (value && !isNaN(value.getTime())) {
                          value = value.getTime();
                          value = new Date(
                            Date.UTC(
                              new Date(value).getFullYear(),
                              new Date(value).getMonth(),
                              new Date(value).getDate()
                            )
                          );
                          value = value.getTime();
                        } else value = -999;
                        updateInvoiceLineItemFeild(
                          invoiceItemIndex,
                          "invoiceDate",
                          
                         value,
                          
                        );
                        saveInvoiceLineItemFeild(
                          invoiceItemIndex,
                          "invoiceDate",
                         
                        );
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column className="no-field-margin" width="3">
                    <InputField
                      id={`${invoiceItemIndex}poNumber`}
                      //  errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'IRTax'}${merchandiseId}`]}
                      disabled={isPscMode ? false: isDisabled('invoiceItem')}
                      type={"text"}
                      className={"field-bg"}
                      label={"po number"}
                      value={poNumber  ==="-999" ?  "" :  poNumber||''}
                      //  isInteger={true}
                      handleFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(value) => {
                        updateInvoiceLineItemFeild(
                          invoiceItemIndex,
                          "poNumber",
                          value
                        );
                      }}
                      onBlur={(value) => {
                        saveInvoiceLineItemFeild(invoiceItemIndex, "poNumber");
                      }}
                      newValue={newValue}
                      fieldName={fieldName}
                      setINPUTID={setINPUTID}
                      penClicked={penClicked}
                      shipmentId={shipmentId}
                      rbCounterID={rbCounterID}
                    />
                  </Grid.Column>
                  <Grid.Column className="no-field-margin borderEnd" width="4">
                    <InputField
                      id={`incoTerms-${invoiceItemIndex}`}
                      disabled={true}
                      className={"field-bg"}
                      label={"IncoTerms®"}
                      value={incoterm1}
                      newValue={incoterm1}
                      fieldName={fieldName}
                      shipmentId={shipmentId}
                    />
                  </Grid.Column>
                  {/* {this.props.showFrightData === false && (
                    <Grid.Column className="no-field-margin" width="1">
                      <Popup
                        trigger={
                          <Icon
                            style={{
                              color: "#1765AE",
                              float: "right",
                              marginTop: "10px",
                              cursor: 'pointer',
                            }}
                            disabled={isPscMode ? false: isDisabled('invoiceItem')}
                            name="dolly"
                            onClick={() => {
                    const error = this.validateInvoiceAmount(merchandiseLineItems)
                          if(error.length > 0 ){
                            confirmAlert({
                          title: error[0].title,
                          message: error[0].message,
                          buttons: [{
                              label: 'OK',
                              onClick: () => {
                                this.props.displayFrightData(invoiceItemIndex, false)
                              }
                            }
                          ]
                        }) 
                      
                          }
                          else{
                            this.props.displayFrightData(invoiceItemIndex,true)
                          
                          }
                          
                            }}
                        
                          />
                        }
                        content={"Add Freight Level Details"}
                      />
                    </Grid.Column>
                  )} */}
                </Grid.Row>
                {/* {this.props.showFrightData === true && ( */}
                  <Grid.Row className="merged hts-row noBottomBorders noTopBorders noWrap">
                    <Grid.Column className="no-field-margin noRightBorders" width={4 + (currencyExchangeInfo.fromIsoCurrencyCode == "USD"?3:0)}>
                      <SelecTextField
                        id={`invoiceAmount-${invoiceItemIndex}`}
                        errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'invoiceAmount'}`]}
                      disabled={isPscMode ? false: isDisabled('invoiceItem')}
                        type={"number"}
                        saveOnTabOut={true}
                        subLabelText="$"
                        subLabelClass="left-icon"
                        className={"field-bg"}
                        label={"invoice amount"}
                        labelIcon={<PopUpIcon icon='info circle' popupText={'Calculated Based On Line Items '} />}
                        value={totalForeignValue}//(invoiceAmount  ==="-999"||invoiceAmount  ===-999) ?  "0.00" :  parseFloat(invoiceAmount||0.00).toFixed(2)||'0.00'}
                        isInteger={true}
                        handleFocus={(e) => {
                          // e.target.select();
                        }}
                        updateValue={(value) => {
                          // updateInvoiceLineItemFeild(
                          //   invoiceItemIndex,
                          //   "invoiceAmount",
                          //   value
                          // );
                        }}
                        onBlur={(value) => {
                          // updateInvoiceLineItemFeild(
                          //   invoiceItemIndex,
                          //   "invoiceAmount",
                          //   parseFloat(value || 0).toFixed(2)
                          // );

                          // saveInvoiceLineItemFeild(
                          //   invoiceItemIndex,
                          //   "invoiceAmount"
                          // );
                        }}
                        options={allcurrenciesForUI}
                        dropDownValue={currencyExchangeInfo.fromIsoCurrencyCode || "Please select currency"}
                        updateDropDownValue={(value) => {
                          this.setState({currencyJustChanged: true});
                          if(!value || value.length==1)return;
                          console.log('vaxlue: ', value,currencyExchangeInfo);
                          if(value === "USD"){
                            currencyExchangeInfo.exchangeRate = 1;
                          }
                          const newExchangeInfo =
                          {
                            ...currencyExchangeInfo,
                            exchangeDate: epochToMMDDYY(exportDateq.epochs),
                            fromIsoCurrencyCode:value,
                            "enteredManuallyByBroker": "false",
                            exchangeRate: null,
                          };
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "currencyExchangeInfo",
                            newExchangeInfo
                          );

                          saveInvoiceLineItemFeildBetterObject(invoiceId, {currencyExchangeInfo:newExchangeInfo})

                      
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    {currencyExchangeInfo.fromIsoCurrencyCode != "USD" && 
                    <Grid.Column className="no-field-margin labelMaxWidth" width="5">
                      <InputField
                      
                        saveOnTabOut={true}
                        id={`foreignCurrencyToUsdExchangeRate-${invoiceItemIndex}`}
                        disabled={exchangeRateIsDisabled}
                        //    errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'IRTax'}${merchandiseId}`]}
                         errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'exchangeRate'}`]}
                        type={"number"}
                        subLabelClass="left-icon"
                        className={"field-bg"}
                        label={<>Exchange Rate {!currencyExchangeInfo?.fromIsoCurrencyCode?"(Set a currency first)":""}&nbsp; &nbsp; 
                        
                        <span style={{float: "right",display:'inline-block'}}>{currencyExchangeInfo.enteredManuallyByBroker=="true"?'[OVERRIDE]':''}
                        
                        <Icon
                            style={{
                              paddingLeft: "3px",
                              color: "gray",
                              cursor: trueExchangeRate?"pointer":"auto",
                            }}
                            title={`Export date is ${(new Date(exportDateq?.epochs).getUTCMonth()+1).toString().padStart(2,"0")}/${new Date(exportDateq?.epochs).getUTCDate().toString().padStart(2,"0")}/${new Date(exportDateq?.epochs).getUTCFullYear()} MM/DD/YYYY
${(trueExchangeRate && trueExchangeRate != currentExchangeRate)? `Reported Exchange rate is ${trueExchangeRate}`:
trueExchangeRate?"":"No reported exchange rate"}
1000 ${currencyExchangeInfo.fromIsoCurrencyCode} = ${(1000 * currentExchangeRate).toFixed(3)} USD
1000 USD = ${(1000 / currentExchangeRate).toFixed(3)} ${currencyExchangeInfo.fromIsoCurrencyCode}
${(trueExchangeRate && trueExchangeRate != currentExchangeRate)? `Click to use reported exchange rate ${trueExchangeRate}`:''}`
                            }
                            name='info circle'
                            className="close link icon"
                            onClick={() => {
                              if(isPscMode ? false: isDisabled('invoiceItem'))return;//disabled=
                              if(isBrokerKnAdmin)return;
                              if(!trueExchangeRate)return;

                              updateExchangeRateForForeignCurrency(trueExchangeRate,hasAnyFreight,true, false);

                            }}
                          />
                          </span>
                        </>}
                        value={currentExchangeRate || this.state.exchangeRateFocusedYes?currentExchangeRate:0.0}
                        isInteger={true}
                        handleFocus={(e) => {
                          this.setState({exchangeRateFocusedYes:true});
                          e.target.select();
                        }}
                        onChange={(value) => {
                          this.setState({exchangeRateChangedYes:true});
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "currencyExchangeInfo",
                            {
                              ...currencyExchangeInfo,
                              exchangeDate: epochToMMDDYY(exportDateq.epochs),
                              "enteredManuallyByBroker": "true",
                              exchangeRate:value}
                          );

                        }}
                        onBlur={(value) => {
                          updateExchangeRateForForeignCurrency(value,hasAnyFreight,true, this.state.exchangeRateChangedYes?true:"noChange");
                          this.setState({exchangeRateFocusedYes:false, exchangeRateChangedYes: false});
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    }
                    
                    {currencyExchangeInfo.fromIsoCurrencyCode != "USD" &&
                    <Grid.Column className="no-field-margin" width="3">
                      <InputField
                        id={`foreignCurrencyConverted-${invoiceItemIndex}`}
                        //    errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'IRTax'}${merchandiseId}`]}
                        disabled={true}
                        type={"number"}
                        subLabelText="$"
                        subLabelClass="left-icon"
                        className={"field-bg"}
                        label={"converted value"}
                        value={(invoiceAmount  ==="-999"||invoiceAmount  ===-999) ?  "0.00" :  parseFloat(invoiceAmount||0.00).toFixed(2)||'0.00'}
                        isInteger={true}
                        handleFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(value) => {
                          // updateInvoiceLineItemFeild(
                          //   invoiceItemIndex,
                          //   "foreignCurrencyConverted",
                          //   value
                          // );
                        }}
                        onBlur={(value) => {
                          // updateInvoiceLineItemFeild(
                          //   invoiceItemIndex,
                          //   "foreignCurrencyConverted",
                          //   parseFloat(value || 0).toFixed(2)
                          // );

                          // saveInvoiceLineItemFeild(
                          //   invoiceItemIndex,
                          //   "foreignCurrencyConverted"
                          // );
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>}
                    
                    
                    <Grid.Column
                      className="no-field-margin"
                      width={5 + (currencyExchangeInfo.fromIsoCurrencyCode == "USD"?4:0)}
                    >
                      <InputField
                        id={`totalEnteredValue-${invoiceItemIndex}`}
                        //    errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'IRTax'}${merchandiseId}`]}
                        disabled={true}
                        type={"number"}
                        className={"field-bg"}
                        subLabelText="$"
                        subLabelClass="left-icon"
                        label={"Total Entered Value"}
                        value={(totalEnteredValue  ==="-999" )?  "" :   
                              hasAnyFreight?parseFloat(totalEnteredValue||0.00).toFixed(2):
                              (parseFloat(invoiceAmount||0.00)).toFixed(2)}
                        isInteger={true}
                        handleFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(value) => {
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "totalEnteredValue",
                            value || "0.00"
                          );
                        }}
                        onBlur={(value) => {
                          value=value  || "0.00"
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "totalEnteredValue",
                            parseFloat(value).toFixed(2)
                          );
                          saveInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "totalEnteredValue"
                          );
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column
                      className="no-field-margin borderEnd"
                      width={3}
                    >
                      <InputField
                        id={`totalCharges-${invoiceItemIndex}`}
                        //    errors={fieldValidation.validObjects_bl[`Merchandiseqwqr${'IRTax'}${merchandiseId}`]}
                        disabled={isPscMode ? false: isDisabled('invoiceItem')}
                        type={"number"}
                        className={"field-bg"}
                        subLabelText="$"
                        subLabelClass="left-icon"
                        label={"Total Charges"}
                        value={totalCharges || ""}
                        isInteger={true}
                        handleFocus={(e) => {
                          e.target.select();
                        }}
                        onChange={(value) => {
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "totalCharges",
                            value
                          );
                          this.setState({invoiceTotalChargesChanged:true});
                        }}
                        onBlur={(value) => {
                          if(this.state.invoiceTotalChargesChanged){
                            value=value  || "0.00"
                            updateInvoiceLineItemFeild(
                              invoiceItemIndex,
                              "totalCharges",
                              parseFloat(value).toFixed(2)
                            );
                            saveInvoiceLineItemFeild(
                              invoiceItemIndex,
                              "totalCharges"
                            );
                          }
                          this.setState({invoiceTotalChargesChanged:false});
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                   
                  </Grid.Row>
                  <Grid.Row className="merged hts-row finalRowz">
                    <Grid.Column className="no-field-margin" width="3">
                      <InputField
                        id={`${invoiceItemIndex}frieghtCharges`}
                        errors={this.state.displayFreightError}
                        disabled={isPscMode ? false: isDisabled('invoiceItem')}
                        type={"text"}
                        className={"field-bg"}
                        subLabelText = {frieghtCharges  ==="-999" || frieghtCharges === "0.00" || !frieghtCharges   ? "" :"$"}
                        subLabelClass=  {frieghtCharges  ==="-999" || frieghtCharges === "0.00" || !frieghtCharges   ? "" :"left-icon"}
                        label={"freight charges"}
                        clearInput = {true}
                        value={this.state.freightChargesxFocused?this.state.freightChargesxValue:(frieghtCharges  ==="-999" || frieghtCharges ==="0.00")?  "" :  frieghtCharges||''}
                        isInteger={false}
                        handleFocus={(e) => {
                          this.setState({freightChargesxFocused:true,freightChargesxValue:(frieghtCharges  ==="-999" || frieghtCharges === "0.00") ?  "" :  frieghtCharges||''})
                          e.target.select();
                        }}
                        onChange={(value) => {
                          this.setState({freightChargesxFocused:true,freightChargesxValue:value})
                      
                            updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "frieghtCharges",
                            value || "0.00"
                          );
                          
                        
                        }}
                        onBlur={(value) => {
                          this.setState({freightChargesxFocused:false})
                          value=value  || "0.00"
                          if (this.getFreightDataValidationError("freight charges",
                              value, frieghtInsurance,
                              otherDeductions , invoiceAmount
                            ).length > 0) {
                            this.setState({
                              displayFreightError: this.getFreightDataValidationError("freight charges",
                                value, frieghtInsurance,
                                otherDeductions , invoiceAmount
                              )
                            })
                          }else{
                            this.setState({displayFreightError : [] })
                  
                          }
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "frieghtCharges",
                            parseFloat(value)
                          );
                          saveInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "frieghtCharges"
                          );
                          clearTimeout(window.GLOBAL_last_calc_save_call);
                          window.GLOBAL_last_calc_save_call =setTimeout(()=>{//We need to delay, otherways save_entry_summary_duties will come back with the old value 
                            updateExchangeRateForForeignCurrency(currentExchangeRate,hasAnyFreight,true, "noChange");
                          },2500)
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" width="3">
                      <InputField
                        id={`${invoiceItemIndex}frieghtIns`}
                        errors={this.state.displayFreightError}
                        disabled={isPscMode ? false: isDisabled('invoiceItem')}
                        type={"text"}
                        className={"field-bg"}
                        subLabelText = {frieghtInsurance  ==="-999" || frieghtInsurance === "0.00" || !frieghtInsurance  ? "" :"$"}
                        subLabelClass=  {frieghtInsurance  ==="-999" || frieghtInsurance === "0.00" || !frieghtInsurance   ? "" :"left-icon"}
                        label={"freight ins."}
                        clearInput = {true}
                        value={this.state.freightInsFocused?this.state.freightInsValue:(frieghtInsurance  ==="-999" || frieghtInsurance === "0.00") ?  "" :  frieghtInsurance||''}
                        isInteger={false}
                        handleFocus={(e) => {
                          this.setState({freightInsFocused:true,freightInsValue:(frieghtInsurance  ==="-999" || frieghtInsurance === "0.00") ?  "" :  frieghtInsurance||''})
                          e.target.select();
                        }}
                        onChange={(value) => {
                          this.setState({freightInsFocused:true,freightInsValue:value})
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "frieghtInsurance",
                            value || "0.00"
                          );
                        }}
                        onBlur={(value) => {
                          this.setState({freightInsFocused:false})
                          
                          value=value  || "0.00"
                          if (this.getFreightDataValidationError("freight ins.",
                          frieghtCharges, value,
                              otherDeductions , invoiceAmount
                            ).length > 0) {
                            this.setState({
                              displayFreightError: this.getFreightDataValidationError("freight charges",
                              frieghtCharges, value,
                                otherDeductions , invoiceAmount
                              )
                            })
                          }else{
                            this.setState({displayFreightError : [] })
                  
                          }

                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "frieghtInsurance",
                            parseFloat(value)
                          );
                          saveInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "frieghtInsurance"
                          );
                          clearTimeout(window.GLOBAL_last_calc_save_call);
                          window.GLOBAL_last_calc_save_call =setTimeout(()=>{//We need to delay, otherways save_entry_summary_duties will come back with the old value 
                            updateExchangeRateForForeignCurrency(currentExchangeRate,hasAnyFreight,true, "noChange");
                          },2500)
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" width="3">
                      <InputField
                        id={`${invoiceItemIndex}otherCharges`}
                        errors={this.state.displayFreightError}
                        disabled={isPscMode ? false: isDisabled('invoiceItem')}
                        type={"text"}
                        className={"field-bg"}
                        subLabelText = {otherDeductions  ==="-999" || otherDeductions === "0.00" || !otherDeductions? "" :"$"}
                        subLabelClass=  {otherDeductions  ==="-999" || otherDeductions === "0.00" || !otherDeductions? "" :"left-icon"}
                        label={"other deductions"}
                        clearInput = {true}
                        value={this.state.otherDeductionsFocused?this.state.otherDeductionsValue:(otherDeductions  ==="-999" || otherDeductions === "0.00" ) ?  "" :  otherDeductions||''}
                        isInteger={false}
                        handleFocus={(e) => {
                          this.setState({otherDeductionsFocused:true,otherDeductionsValue:(otherDeductions  ==="-999" || otherDeductions === "0.00") ?  "" :  otherDeductions||''})
                          e.target.select();
                        }}
                        onChange={(value) => {
                          this.setState({otherDeductionsFocused:true,otherDeductionsValue:value})
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "otherDeductions",
                            value || "0.00"
                          );
                        }}
                        onBlur={(value) => {
                          this.setState({otherDeductionsFocused:false})
                          value=value  || "0.00"
                          if (this.getFreightDataValidationError("other deductions",
                          frieghtCharges,
                          frieghtInsurance , value, invoiceAmount
                            ).length > 0) {
                            this.setState({
                              displayFreightError: this.getFreightDataValidationError("other deductions",
                              frieghtCharges, frieghtInsurance,
                              value , invoiceAmount
                              )
                            })
                          }else{
                            this.setState({displayFreightError : [] })
                     
                          }

                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "otherDeductions",
                            parseFloat(value)
                          );

                          saveInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "otherDeductions"
                          );
                          clearTimeout(window.GLOBAL_last_calc_save_call);
                          window.GLOBAL_last_calc_save_call =setTimeout(()=>{//We need to delay, otherways save_entry_summary_duties will come back with the old value 
                            updateExchangeRateForForeignCurrency(currentExchangeRate,hasAnyFreight,true, "noChange");
                          },2500)
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column
                      className="no-field-margin"
                      width="3"
                    >
                     <InputField
                        id={`${invoiceItemIndex}otherAdditions`}
                        // errors={this.state.displayFreightError}
                        disabled={isPscMode ? false: isDisabled('invoiceItem')}
                        type={"text"}
                        className={"field-bg"}
                        subLabelText = {otherAdditions  ==="-999" || otherAdditions === "0.00" || !otherAdditions? "" :"$"}
                        subLabelClass=  {otherAdditions  ==="-999" || otherAdditions === "0.00" || !otherAdditions? "" :"left-icon"}
                        label={"other additions"}
                        clearInput = {true}
                        value={this.state.otherAdditionsFocused?this.state.otherAdditionsValue:(otherAdditions  ==="-999" || otherAdditions === "0.00" ) ?  "" :  otherAdditions||''}
                        isInteger={false}
                        handleFocus={(e) => {
                          this.setState({otherAdditionsFocused:true,otherAdditionsValue:(otherAdditions  ==="-999" || otherAdditions === "0.00") ?  "" :  otherAdditions||''})
                          e.target.select();
                        }}
                        onChange={(value) => {
                          this.setState({otherAdditionsFocused:true,otherAdditionsValue:value})
                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "otherAdditions",
                            value || "0.00",
                          );
                        }}
                        onBlur={(value) => {
                          this.setState({otherAdditionsFocused:false})
                          value=value  || "0.00"
                          // if (this.getFreightDataValidationError("other Additions",
                          // frieghtCharges,
                          // frieghtInsurance , value, invoiceAmount, parseFloat(value)
                          //   ).length > 0) {
                          //   this.setState({
                          //     displayFreightError: this.getFreightDataValidationError("other Additions",
                          //     frieghtCharges, frieghtInsurance,
                          //     value , invoiceAmount, parseFloat(value)
                          //     )
                          //   })
                          // }else{
                          //   this.setState({displayFreightError : [] })
                     
                          // }

                          updateInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "otherAdditions",
                            parseFloat(value)
                          );

                          saveInvoiceLineItemFeild(
                            invoiceItemIndex,
                            "otherAdditions"
                          );
                          clearTimeout(window.GLOBAL_last_calc_save_call);
                          window.GLOBAL_last_calc_save_call =setTimeout(()=>{//We need to delay, otherways save_entry_summary_duties will come back with the old value 
                            updateExchangeRateForForeignCurrency(currentExchangeRate,hasAnyFreight,true, "noChange");
                          },2500)
                        }}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    <Grid.Column className="no-field-margin" width="2">
                      <InputField
                        id={`${invoiceItemIndex}totalAdditions`}
                        disabled={true}
                        type={"text"}
                        className={"field-bg"}
                        label={"Total Additions"}
                        clearInput = {true}
                        value={totalAdditions}
                        isInteger={false}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                     <Grid.Column className="no-field-margin borderEnd" width="2">
                      <InputField
                        id={`${invoiceItemIndex}totalDeductions`}
                        disabled={true}
                        type={"text"}
                        className={"field-bg"}
                        label={"Total Deductions"}
                        clearInput = {true}
                        value={totalDeletions}
                        isInteger={false}
                        newValue={newValue}
                        fieldName={fieldName}
                        setINPUTID={setINPUTID}
                        penClicked={penClicked}
                        shipmentId={shipmentId}
                        rbCounterID={rbCounterID}
                      />
                    </Grid.Column>
                    {/* <Grid.Column width="1">
                      <Icon
                        style={{
                          color: "#1765AE",
                          float: "right",
                          marginTop: "15px",
                        }}
                        name="trash"
                        onClick={() => {
                          removeFrieghtLevelDetails(invoiceItemIndex);
                      //    this.setState({ showFrightData: false });
                      this.props.displayFrightData(invoiceItemIndex,false)
                
                        }}
                        disabled={isPscMode ? false: isDisabled('invoiceItem')}
                      />
                    </Grid.Column> */}
                  </Grid.Row>
                {/* )} */}
                <Grid.Row className="merged hts-row">
                  <Grid.Column width="12"></Grid.Column>
                  <Grid.Column width="4" style={{ marginTop: "5px" }}>
                   
                  </Grid.Column>
                </Grid.Row>
                <MerchandiseLineItems
                  isPscMode={isPscMode}
                  merchandiseItemCount={this.props.merchandiseItemCount}
                  pscState={get(this.props, "pscState")}
                  modeOfTransport={this.props.modeOfTransport}
                  invoiceItemIndex={invoiceItemIndex}
                  validateFormzz={this.props.validateFormzz}
                  expandAll={this.props.expandAll}
                  invoiceIndex={invoiceIndex}
                  isDisabled={isDisabled}
                  showFrightData={checkFrieghtShouldBeDispalyed(this.props.invoiceItem.frieghtCharges,this.props.invoiceItem.frieghtInsurance , this.props.invoiceItem.otherDeductions, this.props.invoiceItem.otherAdditions)}
                  expandAllLines={this.state.expandAllLines}
                  refreshESFrom={refreshESFrom}
                  shipmentETA={shipmentETA}
                  updateType={this.props.updateType}
                  currentJobData={currentJobData}
                  currencyConversionRate={currentExchangeRate}
                  currencyExchangeInfo={currencyExchangeInfo}
                  isBrokerKnAdmin={isBrokerKnAdmin}
                  kxUserBasicInfo={this.props.kxUserBasicInfo}
                />
                <Grid padded>
                  <Grid.Row className="add-merch-line-item">
                    <Grid.Column>
                      <Button
                        className={"add-line-item-btn"}
                        basic
                        color="blue"
                        circular
                        compact
                        disabled={
                          isPSCEditable
                            ? false
                            : isDisabled('addRemoveMerchandiseLineItems',Boolean(formDisabled))
                        }
                      >
                        {!this.state.isAdding ? (
                          <span>
                      <Icon name='add circle' /> 
                      <Dropdown item
                        lazyLoad={true}
      
                        text='Add Merchandise Line Item'>
                      <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => {
                              if(
                                isPSCEditable
                                  ? false
                                  : isDisabled('addRemoveMerchandiseLineItems',Boolean(formDisabled)))return;
                            this.setState({
                              isAdding: true
                            })
                            createMerchandiseLineItem(invoiceId ,invoiceItemIndex ,this.updateAddStatus, 'NormalLineItem', '', pscData.pscShipmentId)
                            }}>Line Item</Dropdown.Item>
                              <Dropdown.Item>
                                <CreateArticleSet
                                  key='articleSetModal' 
                                  refreshESFrom = { this.props.refreshESFrom }
                                  lineItems={merchandiseLineItems}
                                  handleOpen={() => this.handleModalOpen('articleSetModal')}
                                  handleClose={() => this.handleModalClose('articleSetModal')}
                                  updateModelOpen={this.state.articleSetModal}
                                  invoiceindex={invoiceIndex}
                                  invoiceId={invoiceId}
                                  createNewArticleSet={()=>{
                                    createMerchandiseLineItem(invoiceId ,invoiceItemIndex, this.updateAddStatus, 'ArticleHeader', '', pscData.pscShipmentId)
                                  }}
                                  trigger={
                                      <div onClick={()=>{
                                        this.handleModalOpen('articleSetModal')
                                      }}>Article Set </div>
                                  }
                                  shipId={shipmentId}
                              />
                              </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown> 
                      
                    </span>
                        ) : (
                          <span>
                            <Loader
                              active
                              inline
                              size="mini"
                              style={{ marginRight: "10px" }}
                            />
                            Adding Line Item
                          </span>
                        )}
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid>
            )}
          </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    let hasOtherDeductions = false;
    for(let freightValueKey of ['frieghtCharges','frieghtInsurance','otherDeductions']){
      hasOtherDeductions = hasOtherDeductions ||  !!parseInt(state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex][freightValueKey])
    }
    return {
        allCurrencyCodes: state.DropDownValues.allCurrencyCodes.currencyCodes ||[],
        exportDateq: state.TransportationInfo.exportDate,
        countryOfExport: state.EntryTypeInfo.countryOfExport,
        invoiceItemIndex: props.invoiceItemIndex,
        expandInvoiceItem :  state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].expandInvoiceItem,
        invoiceItem :  state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex],
        showLoader : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].showLoader,
        invoiceId : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].invoiceId, 
        invoiceNumber : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].invoiceNumber, 
        invoiceDate : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].invoiceDate, 
        poNumber   : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].poNumber , 
        currency  : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].currency , 
        frieghtCharges  : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].frieghtCharges , 
        currencyExchangeInfo : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].currencyExchangeInfo || {}, 
        frieghtInsurance  : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].frieghtInsurance , 
        otherDeductions   : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].otherDeductions  , 
        otherAdditions   : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].otherAdditions  , 
        totalEnteredValue  : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].totalEnteredValue , 
        totalCharges  : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].totalCharges , 
        invoiceAmount  : state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].invoiceAmount, 
        merchandiseLineItems: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].merchandiseLineItems,
        fieldValidation: state.FieldValidation,
        newValue: state.FormValues.newValue,
        incoterm1: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].incoterm1,
        fieldName: state.FormValues.fieldName,
        setINPUTID: state.FormValues.setINPUTID,
        penClicked: state.FormValues.penClicked,
        shipmentId: state.FormValues.shipmentId,
        rbCounterID: state.FormValues.rbCounterID,
        formDisabled: state.FormValues.formDisabled,
        fieldValidation: state.FieldValidation,
        currentJobData: props.currentJobData,
        pscData: state.PSC,
        totalAdditions: state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].totalAdditions,
        totalDeletions:state.DescriptionOfMerchandise.entrySummaryInvoices[props.invoiceItemIndex].totalDeletions
    
   
  }
}
  
  const mapDispatchToProps = {
    ...actionCreators
  }
  
  export default React.memo(connect(
    mapStateToProps,
    mapDispatchToProps
  )(InvoiceLineItem))
  
